import { useFilterDocumentFilesStore } from "presentation/stores/use-filter-document-files-store";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import DocumentFilesForm from "presentation/components/DocumentFiles/DocumentFilesForm";
import { DocumentFilesType } from "domain/entities/document-files";

const HeaderDocumentFilesGrid: React.FC<{
  mode: "user" | "admin";
  type?: "regulations" | "tutorials";
}> = ({ mode, type }) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const { filters, setFilters, resetFilters } = useFilterDocumentFilesStore();

  const [showModal, setShowModal] = useState(false);
  const toast = useRef<Toast>(null);

  const documentType =
    type === "regulations"
      ? DocumentFilesType.REGULATION
      : DocumentFilesType.TUTORIAL;

  const clearFilter = () => {
    resetFilters();
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const _filters = { ...filters };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const onGlobalFilterChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setGlobalFilterValue(e.target.value);
  };

  useEffect(() => {
    if (filters.query.value !== globalFilterValue) {
      setGlobalFilterValue(filters.query.value);
    }
  }, [filters]);

  const addDocumentFiles = () => {
    setShowModal(true);
  };

  return (
    <>
      <Toast ref={toast} position="bottom-right" />

      <div className="flex justify-content-between">
        <Dialog
          header="Criar Registo"
          visible={showModal}
          onHide={() => setShowModal(false)}
          style={{
          width: "70vw",
          maxWidth: "600px",
          minHeight: "80vh",
          }}
          contentStyle={{ overflowY: "auto" }}
          >
          <DocumentFilesForm
            mode="create"
            type={documentType}
            onSuccess={() => {
              setShowModal(false);

              toast.current?.show({
                severity: "success",
                summary: "Sucesso",
                detail: "Documento criado com sucesso.",
                life: 3000,
              });
            }}
          />
        </Dialog>

        <div>
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              onKeyDown={onKeyDown}
              placeholder="Procurar"
            />
          </IconField>
        </div>

        <div style={{ display: "flex" }}>
          {mode === "admin" && (
            <Button
              type="button"
              icon="pi pi-plus"
              label="Novo Registo"
              outlined
              onClick={addDocumentFiles}
              style={{
                backgroundColor: "#2196f3",
                color: "white",
                borderRadius: "8px",
              }}
            />
          )}

          <div style={{ width: "10px" }} />

          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Limpar"
            outlined
            onClick={clearFilter}
            style={{
              backgroundColor: "white",
              borderColor: "#2196f3",
              color: "#2196f3",
              borderRadius: "8px",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default HeaderDocumentFilesGrid;